export const environment = {
  production: false,
  // apiUrl: 'http://172.16.2.57:4000/api/v1',
  // apiUrl: 'http://127.0.0.1:4000/api/v1',
  apiUrl: 'https://idpmasterapi.katdev.com/api/v1',
  recommendationApiUrl: '',
  jdParserApiUrl: '',
  apiKey: 'dev-api-key',
  baseRoute: '/',
  token: null,
  awsBasePath: '',
  freelancerUrl: '',
  businessUrl: '',
};
